import assessmentListRoute from '@scoring-web/modules/assessment/views/list/assessment-list.route';
import mainRoute from '@scoring-web/modules/main/views/main/main.route';
import { useUserStore } from '@scoring-web/modules/user/stores/user.store';
import loginRoute from '@scoring-web/modules/user/views/login/login.route';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router';
import useIsMsalProcessing from './use-is-msal-processing.hook';

/**
 * Hook for handling authentication state and routing
 * Manages user authentication flow, tab management, and navigation
 */
export default function useAuthHandler() {
  // #region Dependencies
  const { hydrated, token } = useUserStore();
  const navigate = useNavigate();
  const location = useLocation();
  const isMsalProcessing = useIsMsalProcessing();
  // #endregion

  // #region Effects
  useEffect(() => {
    // Wait for store hydration
    if (!hydrated) return;

    const isLoginRoute = location.pathname === loginRoute.path;
    const isPublicRoute = location.pathname === mainRoute.path || isLoginRoute;
    if (isMsalProcessing && isPublicRoute) return;

    // Redirect to login if no token
    if (!token) {
      if (!isLoginRoute) navigate(loginRoute.path);
      return;
    }

    // Redirect to assessment list from root or login
    if (isPublicRoute) navigate(assessmentListRoute.path);
  }, [hydrated, token, location.pathname, navigate, isMsalProcessing]);
  // #endregion
}
